"use client";
import React from "react";
import styled from "styled-components";

const Card = styled.article`
  display: flex;
  flex-direction: column;
  border-radius: 18px;
  position: relative;
  aspect-ratio: 0.712;
  min-width: 320px;
  margin: 15px;
  overflow: hidden;
  width: 320px;

  @media (max-width: 991px) {
    padding: 20px;
  }
`;

const CardImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 18px;
`;

const CardContent = styled.div`
  position: absolute;
  width: calc(90% - 30px);
  max-width: calc(90% - 30px);
  height: calc(100% - 30px);
  max-height: calc(100% - 30px);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding: 15px;
`;

const CardTopArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  max-width: 100%;
`;

const CardTitle = styled.h3`
  color: white;
  font-size: 28px;
  font-family:
    IBM Plex Sans KR,
    -apple-system,
    Roboto,
    Helvetica,
    sans-serif;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: -0.67px;
  text-align: left;
  word-break: keep-all;
  word-wrap: break-word;
  max-width: 100%;

  >span {
    color: rgba(0, 250, 249, 1);
  }
`;

const CardDescription = styled.p`
  color: white;
  font-size: 14px;
  font-family:
    IBM Plex Sans KR,
    -apple-system,
    Roboto,
    Helvetica,
    sans-serif;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: -0.33px;
  margin-top: 5px;
  text-align: left;
  word-break: keep-all;
  word-wrap: break-word;
  max-width: 100%;
`;

const Author = styled.p`
  color: white;
  font-size: 18px;
  font-family:
    Pretendard,
    -apple-system,
    Roboto,
    Helvetica,
    sans-serif;
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: -0.48px;
  margin-top: 40px;
  text-align: left;
`;

export default function TestimonialCard({ image, title, descriptions, author }) {
  return (
    <Card>
      <CardImage src={image} alt="" />
      <CardContent>
        <CardTopArea>
          <CardTitle>{title}</CardTitle>
          {
            descriptions.map((description, index) => (
              <CardDescription key={index}>{description}</CardDescription>
            ))
          }
        </CardTopArea>
        <Author>{author}</Author>
      </CardContent>
    </Card>
  );
}
